// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__uu7RU","row":"styles_row__1HcRg"};